import { render, staticRenderFns } from "./ad-account-binding.vue?vue&type=template&id=3628d248&scoped=true&"
import script from "./ad-account-binding.vue?vue&type=script&lang=js&"
export * from "./ad-account-binding.vue?vue&type=script&lang=js&"
import style0 from "./ad-account-binding.vue?vue&type=style&index=0&id=3628d248&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628d248",
  null
  
)

export default component.exports